import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Navbar.css';

const ALLOWED_USERS = [
  'charles@dukeleads.com',
  'aduke@morganhill.co.uk',
  'jrosenzweig@morganhill.co.uk',
  'rmorton@morganhill.co.uk',
];

const Navbar = ({ isAdminView = false, isAdmin = false }) => {
  const navigate = useNavigate();
  const username = localStorage.getItem('username');
  const canAccessOverview = ALLOWED_USERS.includes(username);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    navigate('/login');
  };

  return (
    <nav className='app-nav'>
      <div className='nav-brand'>
        <button onClick={() => navigate('/')} className='btn btn-ghost'>
          <img src={logo} alt='Company Logo' className='nav-logo' />
        </button>
        {isAdminView && <span className='badge badge-error'>Admin</span>}
      </div>
      <div className='nav-actions'>
        {canAccessOverview && (
          <button
            type='button'
            onClick={() => navigate('/overview')}
            className='btn btn-ghost btn-sm'
          >
            Overview
          </button>
        )}

        {!isAdminView && isAdmin && (
          <button type='button' onClick={() => navigate('/admin')} className='btn btn-ghost btn-sm'>
            Admin Panel
          </button>
        )}
        <span className='nav-user'>{username}</span>
        <button type='button' onClick={handleLogout} className='btn btn-ghost btn-sm'>
          Sign out
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
